import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import { Product } from '../model/Product';
import 'rxjs/add/operator/map';
import { FilterUrlService } from './filter-url.service';
import * as moment from 'moment';

@Injectable()
export class ProductsService {
  url:string = GLOBAL.url+"products";
  filter:string;

  constructor( private http:HttpClient, private _urlService:FilterUrlService ) {
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }

  public getOne(id:number){
    let url = GLOBAL.url+'products'+'/'+id;

    return this.http.get(url ).map( res => {
        return res;
    });
  }

  public get(){
    return this.http.get(this.url+this.filter ).map( res => {
        return res;
    });
  }

  public getDataFiltered(filters){
    let url = this.url+filters;
    console.log(url);
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public getAll(){
    let url = this.url+'?limit=10000';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

  /**
  * Obtiene el listado de productos.
  * @return listado de productos o un error.
  */
  public getSomeProducts(code:string){
    return this.http.get(this.url+'?sort=-code&limit=10&code=><'+code ).map( res => {
      return res;
    });
  }

  public getExcel(params){
    let lote = '';
    let producto = '';
    /*return GLOBAL.url+'excel_by_lots';*/
    if(params.lote != '' && params.lote != null){
      lote = '&lot_id=1'+params.lote;
    }

    if(params.producto != '' && params.producto != null){
      producto = '&pr_id='+params.producto;
    }

    //2018-08-01
    let desde = moment(params.fecha1);
    let hasta = moment(params.fecha2);

    console.log(GLOBAL.url+'excel_by_lots?from='+(desde.year()+'-'+(desde.month()+1)+'-'+desde.date())+'&to='+(hasta.year()+'-'+(hasta.month()+1)+'-'+hasta.date())+''+lote+''+producto);

    return (GLOBAL.url+'excel_by_lots?from='+(desde.year()+'-'+(desde.month()+1)+'-'+desde.date())+'&to='+(hasta.year()+'-'+(hasta.month()+1)+'-'+hasta.date())+''+producto+''+lote);
  }

  public getAllPropertyTypes(){
    let url = GLOBAL.url+'property_types?sort=+id&limit=200';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

  public getAllProperties(){
    let url = GLOBAL.url+'properties?sort=+id&limit=1000';
    return this.http.get(url ).map( res => {
        return res;
    });
  }

  public save(prov:any){
    return this.http.post(this.url, prov)
      .map( data => {
        return data;
      });
  }

  public update(url:string, body){
    return this.http.put(url, body)
      .map( data => {
        return data;
      });
  }

  public delete(url:string){
    return this.http.delete(url).map( response =>{

      return response;
    });
  }

  /**
   * Transforma un objeto a un formato JSON predefinido en el modelo.
   * @param  data Informacion a transformar.
   * @return      Objeto con el formato JSON correcto.
   */
    transformData(data:any){
      //console.log('data',data);
      let p = new Product(
        data['id'],
        data['codigo'],
        data['descripcion'],
        data['grupo'],
        data['codigo_sernapesca'],
        data['promedio']
      );
      return p.getJson();
    }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/products.service.ts